import { render, staticRenderFns } from "./AdminPanelView.vue?vue&type=template&id=b10e0df2&"
import script from "./AdminPanelView.vue?vue&type=script&lang=ts&"
export * from "./AdminPanelView.vue?vue&type=script&lang=ts&"
import style0 from "./AdminPanelView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports